import { html, LitElement } from 'lit-element';
import { getPercentage } from '../headerBlocks/utils.js';

/**
 * @element view-details-modal-multiple-choice
 * @prop {Object} response - Response
 */
export class ViewDetailsModalMultipleChoice extends LitElement {
  static get properties() {
    return {
      response: {
        type: Object,
        attribute: false,
      },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { sessionData, item, studentsNr, studentsAnsweredNr = 1 } =
      this.response || {};

    const percentage = getPercentage(studentsNr, studentsAnsweredNr);

    const { choices, keyMode } = item || {};
    const { value } = sessionData || {};

    if (!choices && !value) return '';

    let valuesToRender = [];
    const charCode = keyMode === 'numbers' ? 49 : 65;

    if (!value) {
      // this applies if the choice mode is checkbox
      valuesToRender = (choices || []).reduce((acc, choice) => {
        if (choice.correct) {
          acc.push(choices.indexOf(choice));
        }

        return acc;
      }, []);
    } else {
      valuesToRender = (choices || []).reduce((acc, choice, index) => {
        if (value.indexOf(choice.value) >= 0) {
          acc.push(index);
        }

        return acc;
      }, []);
    }

    return html`<div>
      <div class="modal-response-content">
        ${valuesToRender.map(index => {
          const { correct, label } = choices[index] || {};
          const correctnessClass = correct ? 'correct' : 'incorrect';

          return html` <div class="modal-response-content-row">
            <div class="header-correct-response-selection ${correctnessClass}">
              ${String.fromCharCode(index + charCode)}
            </div>
            <div class="response-value">
              <math-rendering-element .label=${label}></math-rendering-element>
            </div>
          </div>`;
        })}
      </div>

      <div class="header-students-number">
        ${studentsNr} Student${studentsNr === 1 ? '' : 's'} (${percentage}%)
      </div>
    </div>`;
  }
}

export default ViewDetailsModalMultipleChoice;
